export default __webpack_public_path__ + "static/Why-You-Should-Experience-a-Winter-Christmas-at-Least-Once-hero-image-8eb6b56b1f94783eeedc98ab4e7f0bc9.jpg";